import React, { Component } from "react";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import { BsyDashUtils } from "../../../utils/DashUtils";

import { BsyUtils } from "../../../utils/Utils";
import BsyAlertMenu from "../../BsyAlertMenu";
import BsyDataManage from "../../BsyDataManage";
import BsySlidePane from "../../BsySlidePane";
import _, { remove } from "lodash";
import BsyDashComponent from "../BsyDashComponent";
import { WindowPropsContext, windowProp } from "../component_context.js";
import "./index.css";
import { BsyConfig } from "../../../global/BsyConfig";
let globWidgetsMap = {};
class BsyDash extends Component {
  static contextType = WindowPropsContext;
  static defaultProps = {
    entryId: "",
    appId: "",
    showType: "",
    components: {},
    autoInit: true,
    sizeUnit: 16.66666,
    gap: 10,
    padding: [2, 10],
    isStyleDesignPane: !1,
    hasLazyLoad: true, // 开启加载，排序加载的逻辑就将失效 2025 05 21
    supportExport: !0,
    defaultStyles: "preset_style_light_1",
    styles: null,
    scrollView: null,
    popupFormPath: [],
    mode: "visit",
    // isDraggable: false,
    // isResizable: false,
    // rowHeight: 15,
    isComponentFull: false,
    cols: 60,
    cacheFilter: 0,
    showFilter: 0,
    // rel: "and",
    prefix: "",
    containiershowStyle: "",
  };
  constructor(props) {
    super(props);
    this.overallBlocks = this.props.overallBlocks || []; //容器记录排序
    this.overalDashList = this.props.overalDashList || []; //容器排序中的DashList
    this.overallBlockMap = this.props.overallBlockMap || {}; //容器记录排序的map
    // this.refreshMap = this.props.refreshMap || {}; // widgetId || appId.formId 对应关系
    // this.refresWidgetMapTime = this.props.refresWidgetMapTime || {};  //widget : updataTime  每个组件最后更新时间
    // this.refreshNewUpdataTime = this.props.refreshNewUpdataTime || {};
    // this.rel = this.props.rel || "and";
    this.state = {
      entryId: props.entryId,
      appId: props.appId,
      components: props.components,
      componentsArray: this.toArray(props.components),

      allComponentDash: props.allComponentDash,
      containiershowStyle: props.containiershowStyle,
      sizeUnit: props.sizeUnit,
      isStyleDesignPane: props.isStyleDesignPane,
      hasLazyLoad: props.hasLazyLoad,
      supportExport: props.supportExport,
      defaultStyles: props.defaultStyles,
      styles: props.styles,
      scrollView: props.scrollView,
      popupFormPath: props.popupFormPath,
      mode: props.mode,
      isDashFull: props.isDashFull,
      isComponentFull: props.isComponentFull,
      autoRefresh: props.autoRefresh || { enabled: false },
      cacheFilter: props.cacheFilter,
      showFilter: props.showFilter,
      showType: props.showType,
      dashTitle: props.name,
      autoInit: props.autoInit,
      // filter: props.filter
    };

    // this.allComponentDashArray= this.toArray(props.allComponentDash.entry.components)
    this.popupFormPath = [...props.popupFormPath];
    this.autoLoad = props.autoLoad;
    this.element = React.createRef();
    // this.filter = props.globFilter || {};
    this.dashMap = {};
    // this.widgetsMap = this.props.widgetsMap || {};
    this.widgetsMapName = {};
    this.widgetsObject = this.props.widgetsObject || []; //联动的对象
    this.widgetsValue = this.props.widgetsValue || []; //记录被联动的数据

    // this.styles = props.styles ? props.styles : null;// BsyDashUtils().getDashStylesDefault(props.defaultStyles)
    this.styles = props.styles
      ? props.styles
      : BsyDashUtils().getDashStylesDefault(props.defaultStyles);
    this.theme = this.styles && this.styles.theme && this.styles.theme.name;
    // console.log('---dash---', this.styles)

    this._initSizeUnit();
    if (this.state.containiershowStyle !== "base_layout_container") {
      this.getDashCustomStyle(this.state.allComponentDash.entry.components);
    }
    this.timeOutHandler = BsyUtils.UUID();
    this.Acomponents = JSON.parse(JSON.stringify(this.state.allComponentDash));
  }

  toArray = (obj) => {
    let arrs = [];
    for (const key in obj) {
      const element = obj[key];

      if (!element || !element.widgetId) {
        continue;
      }

      if (typeof element !== "function") {
        arrs.push({ ...element });
      }
    }
    let that = this;

    //记录控件的在位置
    this.blocks = [];

    this.blockMap = {};
    // t.hasFilterBtn
    BsyUtils.forEach(obj, (e, i) => {
      if (i && !BsyUtils.isString(i) && i.type) {
        if (
          i.type &&
          i.type.indexOf("filter") === -1 &&
          i.type.indexOf("description") === -1
        ) {
          let pos =
            "posY:" +
            BsyUtils.prefixInteger(i.posY, 6) +
            "_" +
            "posX:" +
            BsyUtils.prefixInteger(i.posX, 6);
          that.blocks.push(pos);
          that.blockMap[pos] = i;
          that.overallBlockMap[pos] = i;
        }
      }
    });

    this._blockSort();
    return arrs;
  };

  _blockSort = () => {
    let t = this;
    let tmp = [];

    //排序
    tmp = t.blocks.sort(function (a, b) {
      return a.localeCompare(b);
    });

    t.blocks = [...tmp];
    this.overallBlocks.push(t.blocks);
    let tmpMap = {}; //由父级与子级的对应关系
    t.dashList = [];
    BsyUtils.forEach(tmp, function (a1, b1) {
      t.dashList.push(t.blockMap[b1].widgetId);
      t.overalDashList.push(t.blockMap[b1].widgetId);
      if (tmp[a1 + 1]) {
        tmpMap[t.blockMap[b1].widgetId] = t.blockMap[tmp[a1 + 1]].widgetId;
      }
    });

    //记录加载的排序
    t.dashMap = { ...tmpMap };
  };

  componentDidMount() {
    const { autoInit, components, allComponentDash } = this.state;
    this.context.upOverallSituationValue("rel", this.props.rel);
    if (this.props.getContext) {
      this.props.getContext(this);
    }
    let that = this;
    this._initSizeUnit();

    this.hasFilterBtn = !1;

    BsyUtils.forEach(allComponentDash.entry.components, function (t, i) {
      if (i.type === "filte_quick") {
      }
      if (!i || !i.widgetId) {
        return true;
      }
      i && "filter_btn" === i.type && (that.hasFilterBtn = !0);
    });

    if (autoInit) {
      // console.log('初始化')
      this._initFilter();
    }

    if (this.state.containiershowStyle === "base_layout_container") {
      BsyUtils.forEach(that.widgetsObject, function (key, item) {
        that._triggerLink(item, that.widgetsValue[key]);
      });
    }

  }

  clearValue(obj) {
    Object.keys(obj).forEach((key) => {
      delete obj[key];
    });
  }

  ResetFilter = () => {
    let t = this.state,
      e = this;
    let that = this;
    // this.filter = Object.assign({})
    this.context.upOverallSituationValue("filter", Object.assign({}));
    // BsyUtils.forEach(e.filter,function(key,item){
    //     e.clearValue(item)
    // })

    // this.quikerFilter()
    this.resetQuikerFilter();

    BsyUtils.forEach(t.allComponentDash.entry.components, function (t, i) {
      if (!i || !i.widgetId) {
        return true;
      }

      if (
        i &&
        ("filter_btn" === i.type && (e.hasFilterBtn = !0),
          !(BsyConfig().LimitFields.dashCompFilter.indexOf(i.type) < 0) &&
          i.fields.length)
      ) {
        let a = i.fields[0];
        let n = {
          entryId: a.form,
          field: a.field,
          triggers: i.triggers,
          rely: i.rely,
        };

        if (
          e.state.allComponentDash.entry.components[a.form] &&
          e.state.allComponentDash.entry.components[a.form].background == 1
        ) {
          n.entryId = window.FX.STATIC.entryId;
        }

        if (a.subform) {
          n = {
            ...n,
            ...{
              subform: a.subform,
              subField: a.subField,
            },
          };
        }

        // e.filter[t] = n;
        var filter = that.context.getOverallSituationValue("filter");
        filter[t] = n;
        console.log("q");
        that.context.upOverallSituationValue("filter", filter);

        let valueMode = i.valueMode;
        let method = i.method;
        if (valueMode == "input") {
          if (!i.defaultConfig || !i.defaultConfig.value) {
            i.method = "empty";
          } else {
            if (a.likeMatch === true) {
              i.method = "like";
            } else i.method = "eq";
          }
        }
        e._updateFilter(t, i, i.defaultConfig);
      }
    });

    BsyUtils.forEach(t.allComponentDash.entry.components, function (t, i) {
      if (!i || !i.widgetId) {
        return true;
      }
      if (i.type.indexOf("filter") > -1 || i.type.indexOf("filte") > -1) {
        let context =
          that.context.getOverallSituationValue("widgetsMap")[i.widgetId];
        if (context) {
          context.doFilterRely(
            BsyDashUtils().getFilterRelyFilter(
              i.widgetId,
              that.context.getOverallSituationValue("filter")
            ),
            that.context.getOverallSituationValue("rel")
          );
          context.setDefaultConfig();
        }
      }
    });

    this.setDashFilterCache();
    this._dealFilter();
  };

  // setContainiersRel = (rel) => {

  //     BsyUtils.forEach(this.widgetsMap, (key, widget) => {
  //         if (widget.state.widget.type === "base_layout_container") {
  //             widget.componentContext.setRel(rel)
  //         }
  //     })

  // }

  setContainiersAutoLoad = (auto) => {
    BsyUtils.forEach(
      this.context.getOverallSituationValue("widgetsMap"),
      (key, widget) => {
        if (widget.state.widget.type === "base_layout_container") {
          widget.componentContext.setAutoLoad(auto);
        }
      }
    );
  };

  // 主动触发懒加载，解决多标签切换的时候，组件不加载的问题
  lazyLoad = () => {
    const widgetMap = this.context.getOverallSituationValue("widgetsMap");
    BsyUtils.forEach(this.dashList, (k, v) => {
      widgetMap[v]?.checkInPage()
    })
  }

  setAutoLoad = (auto) => {
    this.autoLoad = auto;
  };

  setRel = (rel) => {
    this.context.upOverallSituationValue("rel", rel);
    // if (this.state.containiershowStyle !== 'base_layout_container') {
    //     this.rel = rel;
    //     this.setContainiersRel(rel)
    //     this.setDashFilterCache();
    //     this._dealFilter();
    //     this._relyFilterAll();
    // } else {
    //     this.rel = rel;
    // }
    this.setDashFilterCache();
    this._dealFilter();
    this._relyFilterAll();
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    let entryChange = false;
    if (nextProps.entryId != this.state.entryId) {
      entryChange = true;
    }

    if (nextProps.isDashFull !== this.state.isDashFull) {
      this._initSizeUnit();
    }
    if (nextProps.isExpand !== this.state.isExpand) {
      this._initSizeUnit();
    }

    // if (nextProps.rel !== this.rel) {
    //     this.setRel(nextProps.rel)
    //     return;
    // }

    if (!BsyUtils.compare(nextProps.components, this.state.components)) {
      this.styles = nextProps.styles
        ? nextProps.styles
        : BsyDashUtils().getDashStylesDefault(this.props.defaultStyles);
      // console.log('---dash---', this.styles)
      this.getDashCustomStyle({ ...nextProps.components });
    }
    // this.allComponentDashArray = this.allComponentDashArray.concat(this.toArray({ ...nextProps.components }))
    this.setState(
      {
        ...nextProps,
        isDashFull: nextProps.isDashFull,
        isExpand: nextProps.isExpand,
        components: { ...nextProps.components },
        componentsArray: this.toArray({ ...nextProps.components }),
      },
      () => {
        if (entryChange) this._initFilter();
      }
    );
  }

  onLoadSuccess = (data) => {
    const { operates, mode } = this.state;
    if (mode !== "edit") {
      if (data.data_update) {
        if (operates.indexOf("tooltip") === -1) {
          let newoperates = ["tooltip", ...operates];
          this.setState({
            operates: newoperates,
            data_update: { ...data.data_update },
          });
        }
      }
    }
  };

  _initSizeUnit = () => {
    let t = this.props;
    let e = 0; // this.element.current.offsetWidth // - 10//- t.gap // - 2 * t.padding[1];
    if (!this.element.current) {
      if (t.showType === "") {
        e = document.body.offsetWidth - 280 - 10; //
      } else {
        e = document.body.offsetWidth;
      }
    } else {
      // 处理容器内的宽度
      if (t.containiershowStyle === "base_layout_container") {
        var ret = BsyUtils.closestClass(
          this.element.current,
          "bsy-base_layout_container"
        );
        e = ret.offsetWidth;
        this.widthUnit = e / t.cols;
        this.heightUnit = t.sizeUnit;
        // 获取到窗口真实宽度后，需要重置刷新一次
        this.setState({});
        return;
      } else e = this.element.current.offsetWidth; //- 10 // - 10//- t.gap // - 2 * t.padding[1];
    }
    if (this.theme === "preset_style_dark_3") {
      e = e - 20;
    }

    this.widthUnit = Math.max(e / t.cols, t.sizeUnit);
    this.heightUnit = t.sizeUnit;
  };
  _getSize = (t) => {
    let e = this.props;

    return {
      x:
        t.posX * this.widthUnit +
        (this.theme === "preset_style_dark_3" ? 10 : 0), //+ 10, //+ e.gap , //+ e.padding[1],
      y: t.posY * this.heightUnit + 10, //e.gap + e.padding[0],
      width: t.width * this.widthUnit - e.gap,
      height: t.height * this.heightUnit - e.gap,
    };
  };

  doResize = () => {
    const { componentsArray } = this.state;
    this._initSizeUnit();
    // this.allComponentDashArray =  unique(this.allComponentDashArray)

    // BsyUtils.forEach(
    //   this.props.allComponentDash.entry.components,
    //   (key, item) => {
    //     const { widgetId, type } = item;
    //     let s = this._getSize(item);
    //     if (!item || !item.widgetId || !this.element || !this.element.current) {
    //       return "";
    //     }
    //     let els = this.element.current.querySelector("." + item.widgetId);
    //     console.log(els);
    //     if (isNaN(s.y)) {
    //       els.style.display = "none";
    //     } else {
    //       els.style.top = s.y + "px";
    //       els.style.left = s.x + "px";
    //       els.style.width = item.type === "webPage" ? "100%" : s.width + "px";
    //       els.style.height =
    //       item.type === "webPage" ? "calc(100% - 10px)" : s.height + "px";
    //     }
    //     if (type.indexOf("chart") > -1 || type !== "base_layout_container") {
    //       const components = this.getWidgetByName(widgetId);
    //       console.log(components)
    //       if (components.componentContext && components.componentContext.doResize) {
    //         components.componentContext.doResize();
    //       }
    //     } else {
    //       console.log(`${type} char not found doResize`);
    //     }
    //   }
    // );

    componentsArray.map((block) => {
      const { widgetId, type } = block;
      let s = this._getSize(block)
      //非法的数据格式
      if (!block || !block.widgetId || !this.element || !this.element.current) {
        return ''
      }
      let els = this.element.current.querySelector('.' + block.widgetId);
      if (isNaN(s.y)) {
        els.style.display = 'none';
      } else {
        els.style.top = s.y + 'px';
        els.style.left = s.x + 'px';
        els.style.width = (block.type === "webPage" ? "100%" : (s.width + 'px'));
        els.style.height = (block.type === "webPage" ? "calc(100% - 10px)" : (s.height + 'px'));
      }
      if (type.indexOf("chart") > -1 || type === "base_layout_container") {
        const components = this.getWidgetByName(widgetId)
        if (components.componentContext.doResize) {

          components.componentContext.doResize();
        }

      } else {
        console.log(`${type} char not found doResize`)
      }

      // top: s.y,
      // left: s.x,
      // width: (block.type === "webPage" ? "100%" : s.width),
      // height: (block.type === "webPage" ? "calc(100% - 10px)" : s.height),
      // display: isNaN(s.y) ? 'none' : 'block'
    })
    function unique(arr1) {
      const res = new Map();
      return arr1.filter(
        (item) => !res.has(item.widgetId) && res.set(item.widgetId, 1)
      );
    }
  };

  getContext = (context) => {
    // if (!this.widgetsMap) {
    //     this.widgetsMap = {};
    //     this.widgetsMapName = {};
    // }
    var widgetsMap = this.context.getOverallSituationValue("widgetsMap");
    // this.widgetsMap[context.state.widget.widgetId] = context;
    widgetsMap[context.state.widget.widgetId] = context;

    this.context.upOverallSituationValue("widgetsMap", widgetsMap);
    this.widgetsMapName[context.state.widget.widgetId] =
      context.state.widget.title;
  };

  getWidgetByName = (t) => {
    return this.context.getOverallSituationValue("widgetsMap")[t];
  };

  getDashCustomStyle = (components) => {
    let that = this;
    if (!that.styles) {
      that.styles = {};
    }
    let d = document.getElementById(that.props.rootTokenDashClass);
    if (d) {
      d.remove();
    }

    let stlyes = "<style id=" + that.props.rootTokenDashClass + " >\n";
    stlyes += BsyDashUtils().getDashStyle(
      this.styles,
      that.props.rootTokenDashClass
    );

    BsyUtils.forEach(components, (k, value) => {
      stlyes += "\n" + that._getWidgetStyle(that.styles, value);
    });

    stlyes += "\n</style>";
    BsyUtils.appendStyle(stlyes);
  };
  _getWidgetStyle = (dashStyles, widget) => {
    widget = widget || {};
    let style = BsyDashUtils().getDashStylesExtendStyles(
      dashStyles,
      widget.styles
    );
    this.widgetStyleMap = this.widgetStyleMap || {};
    this.widgetStyleMap[widget.widgetId] = style;

    if (style) {
      let inlineStyle = BsyDashUtils().getTableInlineStyle(
        widget.widgetId,
        style,
        widget.type,
        this.props.rootTokenDashClass
      );
      return inlineStyle;
    }
    return "";
  };

  _triggerLink = (t, e) => {
    let i = this;
    var oldList = JSON.parse(JSON.stringify(this.widgetsObject));
    BsyUtils.forEach(oldList, function (key, item) {
      if (item.widgetId === t.widgetId) {
        i.widgetsObject.splice(key, 1);
        i.widgetsValue.splice(key, 1);
      }
    });
    i.widgetsObject.push(t);
    i.widgetsValue.push(e);
    BsyUtils.forEach(t.triggers, function (t1, a) {
      let n = i.getWidgetByName(a);
      if (n) {
        //2020 06 02 同来源表数据联动的时候附带上次的条件  bobo
        // n.props.widget.filterbak = e; //备份上次的条件，取消关联后会自动清理
        // let tmp = [];
        // tmp = tmp.concat(e);
        // if (!BsyUtils.isObjectEmpty(t.filterbak))
        //     tmp = tmp.concat(t.filterbak);
        n.setLinkFilter(e);
        n.reload();
      }
    });

    let ex = { ...e };

    BsyUtils.forEach(t.customizeTriggers, function (t, a) {
      let n = i.getWidgetByName(a.widgetId);
      if (n) {
        //点击产生的条件
        let filterMap = {};
        BsyUtils.forEach(ex, function (a1, b1) {
          if (b1) {
            if (b1.subField) {
              filterMap[b1.subform + "." + b1.subField] = b1;
            } else filterMap[b1.field] = b1;
          }
        });

        let entryId = n.state.widget.forms[0];
        if (n.state.widget.background === 1) {
          entryId = window.FX.STATIC.entryId;
        }
        let fields = {};
        if (!BsyUtils.isObjectEmpty(n.state.widget.xFields)) {
          BsyUtils.forEach(n.state.widget.xFields, function (a1, b1) {
            fields[b1.tag] = b1;
          });
        }
        if (!BsyUtils.isObjectEmpty(n.state.widget.yFields)) {
          BsyUtils.forEach(n.state.widget.yFields, function (a1, b1) {
            fields[b1.tag] = b1;
          });
        }
        if (!BsyUtils.isObjectEmpty(n.state.widget.fields)) {
          BsyUtils.forEach(n.state.widget.fields, function (a1, b1) {
            if (b1.type === "subform") {
              BsyUtils.forEach(b1.items, function (a2, b2) {
                let el = {};
                el.title = b2.title;
                el.text = b2.title;
                el.subform = b1.name;
                el.subField = b2.name;
                el.form = b1.form;
                el.name = b1.name;
                el.tag = el.subform + "." + el.subField;
                el.type = b2.type;
                el.method = b2.method;
                el.mode = b2.mode;
                fields[el.tag] = el;
              });
            } else fields[b1.tag] = b1;
          });
        }

        let filter = [];
        BsyUtils.forEach(a.arg, function (a1, b1) {
          let fff = fields[b1.tag];
          if (fff) {
            if (b1.depend && b1.depend.field) {
              let fs = filterMap[b1.depend.field];
              if (fs) {
                let fxs = {};
                fxs.entryId = entryId;
                fxs.method = b1.method;
                fxs.type = fs.type;
                fxs.value = fs.value;
                switch (fs.type) {
                  case "datetime": {
                    if (fs.method == "range") {
                      fxs.method = fs.method;
                    }
                    break;
                  }
                  default:
                }
                if (fff.subform) {
                  let subs = []; // fff.tag.split('.');

                  if (fff.tag.indexOf(".") > -1) {
                    subs = fff.tag.split(".");
                  } else {
                    subs = fff.name.split(".");
                  }

                  fxs.subform = fff.subform;
                  fxs.subField = fff.subField || subs[1];
                  fxs.fields = {};
                  fxs.fields.form = entryId;
                  fxs.fields.subform = fff.subform;
                  fxs.fields.subField = fff.subField || subs[1];
                  fxs.fields.type = fs.type;
                } else fxs.field = fff.name;

                filter.push(fxs);
              }
            } else {
              // entryId: "539a4fb4ad095772913d3396"
              // field: "_widget_1576655595192"
              // method: "in"
              // type: "text"
              // value: ["111"]

              let fxs = {};
              fxs.entryId = entryId;
              fxs.field = fff.name;
              fxs.method = b1.method;
              fxs.type = fff.type;
              switch (fff.type) {
                case "datetime": {
                  if (fff.method == "range") {
                    fxs.method = fff.method;
                  }
                  break;
                }
                default:
              }
              if (fff.subform) {
                let subs = [];
                if (fff.tag.indexOf(".") > -1) {
                  subs = fff.tag.split(".");
                } else {
                  subs = fff.name.split(".");
                }
                // let subs = fff.tag.split('.');
                fxs.subform = fff.subform;
                fxs.subField = fff.subField || subs[1];
                fxs.fields = {};
                fxs.fields.form = entryId;
                fxs.fields.subform = fff.subform;
                fxs.fields.subField = fff.subField || subs[1];
                fxs.fields.type = fff.type;
              } else fxs.field = fff.name;

              if (["not_empty", "empty"].indexOf(fxs.method) == -1) {
                if (BsyUtils.isArray(b1.value)) {
                  fxs.value = b1.value;
                } else {
                  fxs.value = [b1.value];
                }
              }

              filter.push(fxs);
            }
          }
        });
        n.setLinkFilter(filter);
        n.reload();
      }
    });
  };
  quikerFilter = (tt, type) => {
    let that = this;

    if (tt) {
      var quikerComponents =
        this.context.getOverallSituationValue("quikerComponents");
      BsyUtils.forEach(quikerComponents, (key, item) => {
        BsyUtils.forEach(
          item.combineFilterModel.combineFilter,
          (key1, item1) => {
            if (item1.select) {
              BsyUtils.forEach(item1.filters, (key2, item2) => {
                setPrecondition(item2);
                console.log("item2", item2._combineWidgetId);
                that._updateFilter(
                  item2._combineWidgetId,
                  item2,
                  item2.defaultConfig,
                  item.widgetId
                );
              });
            }
          }
        );
      });
    } else {
      BsyUtils.forEach(that.Acomponents.entry.components, function (key, item) {
        if (item.type === "filte_quick") {
          BsyUtils.forEach(
            item.combineFilterModel.combineFilter,
            function (key1, item1) {
              if (item1.select) {
                //初始化
                BsyUtils.forEach(item1.filters, function (key2, item2) {
                  setPrecondition(item2);
                  that._updateFilter(
                    item2._combineWidgetId,
                    item2,
                    item2.defaultConfig,
                    key
                  );
                });
              }
            }
          );
        }
      });
    }

    function setPrecondition(item2) {
      const components = _.cloneDeep(
        that.state.allComponentDash.entry.components
      );
      let a = item2.fields[0];
      let et = {
        entryId: a.form,
        field: a.field,
        triggers: item2.triggers,
        rely: item2.rely,
      };

      if (components[a.form] && components[a.form].background == 1) {
        et.entryId = window.FX.STATIC.entryId;
      }

      if (a.subform) {
        et = {
          ...et,
          ...{
            subform: a.subform,
            subField: a.subField,
          },
        };
      }
      var filter = that.context.getOverallSituationValue("filter");
      filter[item2._combineWidgetId] = et;
      that.context.upOverallSituationValue("filter", filter);
    }
  };
  onQuikerFilterItem = (tt, widgetId, type) => {
    let filter = this.context.getOverallSituationValue("filter");
    let that = this;

    let quikerComponents =
      this.context.getOverallSituationValue("quikerComponents");

    BsyUtils.forEach(filter, function (key, item) {
      if (item.quikerUseWid) {
        //删除快捷方式的筛选
        delete filter[key];
      }
    });
    this.context.upOverallSituationValue("filter", filter);
    // this._initFilter(tt,type) //重新拿值
    console.log(this.context.getOverallSituationValue("filter"));
    this.quikerFilter(tt, type);

    let triggers = [];

    BsyUtils.forEach(that.Acomponents.entry.components, function (key, item) {
      if (item.widgetId === widgetId) {
        BsyUtils.forEach(
          item.combineFilterModel.combineFilter,
          function (key1, item1) {
            BsyUtils.forEach(item1.filters, function (key2, item2) {
              triggers = triggers.concat(item2.triggers);
            });
          }
        );
      }
    });
    triggers = [...new Set(triggers)];
    console.log(triggers);
    this.hasFilterBtn || this._dealFilter(triggers);
  };
  resetQuikerFilter = () => {
    var filter = this.context.getOverallSituationValue("filter");
    BsyUtils.forEach(filter, function (key, item) {
      if (item.quikerUseWid) {
        //删除快捷方式的筛选
        delete filter[key];
      }
    });
    this.context.upOverallSituationValue("filter", filter);
    console.log(this.context.getOverallSituationValue("filter"));
    this.quikerFilter();
  };
  _initFilter = (tt, type) => {
    let t = this.state,
      e = this;
    let that = this;
    this.hasFilterBtn = !1;
    // this.filter = {}

    this.quikerFilter(tt, type);

    const components = _.cloneDeep(t.allComponentDash.entry.components);

    BsyUtils.forEach(components, function (t, i) {
      if (!i || !i.widgetId) {
        return true;
      }

      if (
        i &&
        ("filter_btn" === i.type && (e.hasFilterBtn = !0),
          !(BsyConfig().LimitFields.dashCompFilter.indexOf(i.type) < 0) &&
          i.fields.length)
      ) {
        let a = i.fields[0];
        let n = {
          entryId: a.form,
          field: a.field,
          triggers: i.triggers,
          rely: i.rely,
        };

        if (components[a.form] && components[a.form].background == 1) {
          n.entryId = window.FX.STATIC.entryId;
        }

        if (a.subform) {
          n = {
            ...n,
            ...{
              subform: a.subform,
              subField: a.subField,
            },
          };
        }

        var filter = that.context.getOverallSituationValue("filter");
        filter[t] = n;
        that.context.upOverallSituationValue("filter", filter);

        let valueMode = i.valueMode;
        let method = i.method;
        if (valueMode == "input") {
          if (!i.defaultConfig || !i.defaultConfig.value) {
            i.method = "empty";
          } else {
            if (a.likeMatch === true) {
              i.method = "like";
            } else i.method = "eq";
          }
        }
        if (i.type === "number_filter" && !BsyUtils.isObjectEmpty(i.tick)) {
          let tickValue = i.tickValue;
          let a = i.defaultConfig;
          if (method === "range") {
            if (tickValue && a) {
              if (a.min) {
                switch (tickValue.min) {
                  case "hour": {
                    a.min = a.min * 60 * 60;
                    break;
                  }
                  case "days": {
                    a.min = a.min * 60 * 60 * 24;
                    break;
                  }
                  case "minute":
                  default: {
                    a.min = a.min * 60;
                    break;
                  }
                }
              }
              if (a.max) {
                switch (tickValue.max) {
                  case "hour": {
                    a.max = a.max * 60 * 60;
                    break;
                  }
                  case "days": {
                    a.max = a.max * 60 * 60 * 24;
                    break;
                  }
                  case "minute":
                  default: {
                    a.max = a.max * 60;
                    break;
                  }
                }
              }
            }
          } else {
            if (a && a.value) {
              switch (tickValue) {
                case "hour": {
                  a.value = a.value * 60 * 60;
                  break;
                }
                case "days": {
                  a.value = a.value * 60 * 60 * 24;
                  break;
                }
                case "minute":
                default: {
                  a.value = a.value * 60;
                  break;
                }
              }
            }
          }
        }
        !tt && tt !== "" && e._updateFilter(t, i, i.defaultConfig);
      }
    });

    this.getDashFilterCache();
    BsyUtils.forEach(components, function (t, i) {
      if (!i || !i.widgetId) {
        return true;
      }
      if (i.type.indexOf("filter") == -1) {
        let context = e.context.getOverallSituationValue("widgetsMap")[i.widgetId];
        if (context) {
          // !that.hasFilterBtn && 
          context.setFilter(e._getFilter(i.widgetId), e.filterMap, that.context.getOverallSituationValue("rel"));
        }
      } else {
        let context = e.context.getOverallSituationValue("widgetsMap")[i.widgetId];
        if (context) {
          context.doFilterRely(BsyDashUtils().getFilterRelyFilter(i.widgetId, that.context.getOverallSituationValue("filter")),
            that.context.getOverallSituationValue("rel")
          );
        }
      }
    });
    // 会引起卡片图表数据重复 
    // setTimeout(() => {
    //   if (that.blocks.length) {
    //     that.context
    //       .getOverallSituationValue("widgetsMap")
    //     [that.blockMap[that.blocks[0]].widgetId].loadWidget();
    //   }
    // }, 200);
  };
  _getComboCheckFilter = (t, e) => {
    let i = (e && e.items) || (e && e.value);
    let r = {
      type: t,
      hasEmpty: !(!e || !e.hasEmpty),
      value: !BsyUtils.isObjectEmpty(i) ? BsyUtils.makeArray(i) : [],
      hasCurrentDept: !(!e || !e.hasCurrentDept),
      hasCurrentUser: !(!e || !e.hasCurrentUser),
      hasCurrentSubDept: !(!e || !e.hasCurrentSubDept),
      hasCurrentParDept: !(!e || !e.hasCurrentParDept),
    };
    if (e) {
      r.parentDepts = e.parentDepts ? BsyUtils.makeArray(e.parentDepts) : [];
    }
    switch (r.type) {
      case "user":
      case "usergroup": {
        delete r.parentDepts;
        delete r.hasCurrentDept;
        delete r.hasCurrentSubDept;
        delete r.hasCurrentParDept;
        break;
      }
      case "deptgroup":
      case "dept": {
        delete r.hasCurrentUser;
        break;
      }
      default: {
        delete r.parentDepts;
        delete r.hasCurrentDept;
        delete r.hasCurrentSubDept;
        delete r.hasCurrentParDept;
        delete r.parentDepts;
        delete r.hasCurrentUser;
        break;
      }
    }
    return r;
  };
  _updateFilter = (t, e, i, quikerUseWid) => {
    console.log("t", t);
    let a = e.fields[0],
      n = {};
    // this.filter[t] = this.filter[t] || {}
    n.method = e.method || BsyUtils.getDashDefaultFilterMethod(a && a.type);
    n.fields = e.fields;
    n.triggers = e.triggers;
    n.value = null;
    n.quikerUseWid = quikerUseWid;
    if (a) {
      switch (a.type) {
        case "text":
        case "radiogroup":
        case "combo":
        case "sn":
          n = { ...n, ...this._getComboCheckFilter("text", i) };
          break;
        case "textarea":
          n.type = "textarea";
          let s = i && i.items ? i.items[0] : i && i.value;
          n.value = s ? BsyUtils.makeArray(s) : [];
          break;
        case "combocheck":
        case "checkboxgroup":
          n = { ...n, ...this._getComboCheckFilter("combocheck", i) };
          break;
        case "number":
          n.type = "number";
          i &&
            (n.value = BsyUtils.isEmpty(i.value) ? [i.min, i.max] : [i.value]);
          if (i && i.tickValue) {
            n.tickValue = i.tickValue;
          }
          break;
        case "datetime":
          n.type = "datetime";
          let o = "yyyy-MM-dd";
          switch (e.type) {
            case "datetime_filter": {
              o = "yyyy-MM-dd HH:mm:ss";
              break;
            }
            case "datemonth_filter": {
              o = "yyyy-MM";
              break;
            }
            case "dateyear_filter": {
              o = "yyyy";
              break;
            }
            default:
          }
          // let o = "datetime_filter" === e.type ? "yyyy-MM-dd HH:mm:ss" : "yyyy-MM-dd";
          i && i.value
            ? (n.value = [typeof i.value === 'string' ? i.value : BsyUtils.date2Str(new Date(i.value), o)])
            : i && i.mode
              ? (n.value = i)
              : (n.value = [
                i && i.min ? typeof i.min === 'string' ? i.min : BsyUtils.date2Str(new Date(i.min), o) : null,
                i && i.max ? typeof i.max === 'string' ? i.max : BsyUtils.date2Str(new Date(i.max), o) : null,
              ]);
          break;
        case "address":
        case "location":
          n.type = "address";
          n.value = i ? [i.province, i.city, i.district] : [];
          break;
        case "user":
        case "usergroup":
        case "dept":
        case "deptgroup":
          n = { ...n, ...this._getComboCheckFilter(a.type, i) };
          break;
        case "flowstate":
          n.type = "flowstate";
          let e1 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e1) ? BsyUtils.makeArray(e1) : [];
          break;
        case "assist_prostatus":
          n.type = "assist_prostatus";
          let e4 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e4) ? BsyUtils.makeArray(e4) : [];
          break;
        case "assist_flowid":
          n.type = "assist_flowid";
          let e3 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e3) ? BsyUtils.makeArray(e3) : [];
          break;
        case "flowdecision":
          n.type = "flowdecision";
          let e2 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e2) ? BsyUtils.makeArray(e2) : [];
          break;
        case "upload":
        case "image":
          n.type = "file_list";
          break;
        case "signature":
          n.type = "signature";
          break;
        default:
          break;
      }
    }

    // this.filter[t] = { ...this.filter[t], ...n };

    var filter = this.context.getOverallSituationValue("filter");
    filter[t] = { ...filter[t], ...n };
    this.context.upOverallSituationValue("filter", filter);
    console.log(this.context.getOverallSituationValue("filter"));
    // $.extend(, n)
  };

  _getFilter = (t) => {
    let e = [],
      i = this.state;
    let _this = this;
    this.filterMap = {};

    BsyUtils.forEach(
      _this.context.getOverallSituationValue("filter"),
      function (a, n) {
        let widgetId = a;
        n.triggers &&
          n.method &&
          BsyUtils.forEach(n.triggers, function (a, s) {
            if (s === t) {
              let o = i.allComponentDash.entry.components[t].forms[0];
              let widget = i.allComponentDash.entry.components[t];
              return (
                BsyUtils.forEach(n.fields, function (t, i) {
                  if (i.form === o) {
                    let a = {
                      ...n,
                      ...{
                        entryId: i.form,
                        field: i.field,
                      },
                    };

                    if (widget && widget.background == 1) {
                      a.entryId = window.FX.STATIC.entryId;
                    }
                    if (i.subform) {
                      a = {
                        ...a,
                        ...{
                          subform: i.subform,
                          subField: i.subField,
                        },
                      };
                    } else {
                      a.subform = null;
                      a.subField = null;
                    }
                    e.push(a);

                    // i.subform ? ($.extend(a, {
                    //     subform: i.subform,
                    //     subField: i.subField
                    // }),
                    //     a.field = void 0) : (a.subform = void 0,
                    //         a.subField = void 0),
                    //     e.push(a);

                    _this.filterMap[widgetId] = a;
                    return !1;
                  }
                }),
                !1
              );
            }
          });
      }
    );
    return BsyUtils.getValidFilters({
      cond: e,
    }).cond;
  };

  onFilterStopEdit = (t, e) => {
    let a = t.value;

    let valueMode = t.valueMode;
    let method = t.method;
    if (valueMode == "input") {
      if (!a || !a.value) {
        method = "empty";
      } else {
        if (a.likeMatch === true) {
          method = "like";
        } else method = "eq";
      }
    }

    if (
      a &&
      method != "empty" &&
      method != "not_empty" &&
      e.type === "number_filter" &&
      !BsyUtils.isObjectEmpty(e.tick)
    ) {
      var tickValue = t.tickValue;
      a.tickValue = t.tickValue;
      if (method === "range") {
        if (tickValue && a) {
          if (a.min) {
            switch (tickValue.min) {
              case "hour": {
                a.min = a.min * 60 * 60;
                break;
              }
              case "days": {
                a.min = a.min * 60 * 60 * 24;
                break;
              }
              case "minute":
              default: {
                a.min = a.min * 60;
                break;
              }
            }
          }
          if (a.max) {
            switch (tickValue.max) {
              case "hour": {
                a.max = a.max * 60 * 60;
                break;
              }
              case "days": {
                a.max = a.max * 60 * 60 * 24;
                break;
              }
              case "minute":
              default: {
                a.max = a.max * 60;
                break;
              }
            }
          }
        }
      } else {
        if (a && a.value) {
          switch (tickValue) {
            case "hour": {
              a.value = a.value * 60 * 60;
              break;
            }
            case "days": {
              a.value = a.value * 60 * 60 * 24;
              break;
            }
            case "minute":
            default: {
              a.value = a.value * 60;
              break;
            }
          }
        }
      }
    }
    this._updateFilter(
      e.widgetId,
      {
        ...e,
        ...{
          method: method,
        },
      },
      a
    );
    this.setDashFilterCache();
    this._dealFilterMap();
    console.log(e.triggers);
    this.hasFilterBtn || this._dealFilter(e.triggers);

    this._relyFilter(e);
  };
  _relyFilter = (e) => {
    let that = this;
    BsyUtils.forEach(e.rely, function (t, e1) {
      if (that.context.getOverallSituationValue("widgetsMap")[e1]) {
        if (
          that.context.getOverallSituationValue("widgetsMap")[e1].doFilterRely
        ) {
          that.context
            .getOverallSituationValue("widgetsMap")
          [e1].doFilterRely(
            BsyDashUtils().getFilterRelyFilter(
              e1,
              that.context.getOverallSituationValue("filter")
            ),
            that.context.getOverallSituationValue("rel")
          );
        }
      }
    });
  };

  _relyFilterAll = (e) => {
    let that = this;
    BsyUtils.forEach(
      that.context.getOverallSituationValue("filter"),
      function (t, e1) {
        if (that.context.getOverallSituationValue("widgetsMap")[t]) {
          if (
            that.context.getOverallSituationValue("widgetsMap")[t].doFilterRely
          ) {
            that.context
              .getOverallSituationValue("widgetsMap")
            [t].doFilterRely(
              BsyDashUtils().getFilterRelyFilter(
                t,
                that.context.getOverallSituationValue("filter")
              ),
              that.context.getOverallSituationValue("rel")
            );
          }
        }
      }
    );
  };

  //缓存的时候 同步菜单栏上的 rel
  onCacheSetRel = (rel, cb) => {
    console.log("333", rel);
    if (this.props.onCacheSetRel) {
      this.props.onCacheSetRel(rel, cb);
    }
  };

  //缓存筛选条件
  setDashFilterCache = () => {
    const { cacheFilter, appId, entryId, showType } = this.state;
    if (!appId || !entryId) {
      return;
    }

    if (showType) {
      return;
    }

    let key = `${this.props.prefix}dashFilterCache${appId}${entryId}`;
    if (cacheFilter) {
      // this.filter = this.filter || {}
      // this.filter.rel = this.context.getOverallSituationValue('rel');
      // BsyUtils.Store.set(key, this.filter);

      var filter = this.context.getOverallSituationValue("filter");
      filter.rel = this.context.getOverallSituationValue("rel");
      console.log("q3");
      this.context.upOverallSituationValue("filter", filter);
      BsyUtils.Store.set(key, filter);
    }
  };

  getDashFilterCache = () => {
    const { cacheFilter, showFilter, appId, entryId, showType } = this.state;

    if (!appId || !entryId) {
      return;
    }

    if (showType) {
      return;
    }

    let that = this;
    let key = `${this.props.prefix}dashFilterCache${appId}${entryId}`;
    // let newcomponents = {...components};
    if (cacheFilter) {
      //获取同覆盖默认筛选条件
      let filter = BsyUtils.Store.get(key);

      if (filter && filter["rel"]) {
        if (showFilter) {
          BsyUtils.forEach(filter, (key, value) => {
            // if (that.filter[key]) {
            //     that.filter[key] = value;
            var filter = that.context.getOverallSituationValue("filter");
            if (filter[key]) {
              filter[key] = value;
              console.log("q4");
              that.context.upOverallSituationValue("filter", filter);

              let widget =
                that.context.getOverallSituationValue("widgetsMap")[key];
              if (widget) {
                if (widget.componentContext) {
                  //判断同一个筛选条件 在后端配置切换了类型，导到前端缓存数据不一致报错的问题
                  if (
                    widget.componentContext.props.fields &&
                    widget.componentContext.props.fields.length > 0 &&
                    that.context.getOverallSituationValue("filter")[key]
                      .fields &&
                    that.context.getOverallSituationValue("filter")[key].fields
                      .length > 0 &&
                    widget.componentContext.props.fields[0].field ===
                    that.context.getOverallSituationValue("filter")[key]
                      .fields[0].field
                  ) {
                    let defvalue = that._margedefaultConfig(
                      that.context.getOverallSituationValue("filter")[key]
                    );
                    if (value.type === "number") {
                      widget.componentContext.setValue(
                        defvalue,
                        that.context.getOverallSituationValue("filter")[key]
                          .method,
                        that.context.getOverallSituationValue("filter")[key]
                          .tickValue
                      );
                    } else {
                      widget.componentContext.setValue(
                        defvalue,
                        that.context.getOverallSituationValue("filter")[key]
                          .method
                      );
                    }
                  }
                }
              }
            }
          });
        }
      }
    }
  };

  //转换默认值的格式
  _margedefaultConfig = (filter) => {
    if (!BsyUtils.checkFilterValid(filter)) {
      return {};
    }
    let filterType = BsyUtils._widget_dash_filter(filter.type);
    switch (filterType) {
      case "backflowid_filter":
      case "flownode_filter": {
        return {
          value: filter.value[0],
        };
        break;
      }
      case "flowcreator_filter":
      case "dept_filter":
      case "user_filter":
      case "text_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.LK:
          case BsyConfig().CONST.FILTER_METHOD.ULK:
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.NE: {
            return {
              value: filter.value[0],
            };
            break;
          }
          case BsyConfig().CONST.FILTER_METHOD.IN:
          case BsyConfig().CONST.FILTER_METHOD.NIN: {
            return {
              parentDepts: filter.parentDepts ? filter.parentDepts : [],
              hasCurrentDept: filter.hasCurrentDept
                ? filter.hasCurrentDept
                : false,
              hasCurrentParDept: filter.hasCurrentParDept
                ? filter.hasCurrentParDept
                : false,
              hasCurrentSubDept: filter.hasCurrentSubDept
                ? filter.hasCurrentSubDept
                : false,
              hasCurrentUser: filter.hasCurrentUser
                ? filter.hasCurrentUser
                : false,
              hasEmpty: filter.hasEmpty ? filter.hasEmpty : false,
              items: [...filter.value],
            };
            break;
          }
          default:
        }
        break;
      }
      case "textarea_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.LK:
          case BsyConfig().CONST.FILTER_METHOD.ULK: {
            return {
              value: filter.value[0],
            };
            break;
          }
          default:
        }
        break;
      }
      case "number_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.NE:
          case BsyConfig().CONST.FILTER_METHOD.GT:
          case BsyConfig().CONST.FILTER_METHOD.GTE:
          case BsyConfig().CONST.FILTER_METHOD.LT:
          case BsyConfig().CONST.FILTER_METHOD.LTE: {
            return {
              value: filter.value[0],
            };
            break;
          }
          case BsyConfig().CONST.FILTER_METHOD.RG: {
            return {
              min: filter.value[0],
              max: filter.value[1],
            };
            break;
          }
          default:
        }
        break;
      }
      case "usergroup_filter":
      case "deptgroup_filter":
      case "combocheck_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.ALL:
          case BsyConfig().CONST.FILTER_METHOD.IN: {
            return {
              parentDepts: filter.parentDepts ? filter.parentDepts : [],
              hasCurrentDept: filter.hasCurrentDept
                ? filter.hasCurrentDept
                : false,
              hasCurrentParDept: filter.hasCurrentParDept
                ? filter.hasCurrentParDept
                : false,
              hasCurrentSubDept: filter.hasCurrentSubDept
                ? filter.hasCurrentSubDept
                : false,
              hasCurrentUser: filter.hasCurrentUser
                ? filter.hasCurrentUser
                : false,
              hasEmpty: filter.hasEmpty ? filter.hasEmpty : false,

              items: [...filter.value],
            };
            break;
          }
          default:
        }
        break;
      }
      case "date_filter":
      case "datetime_filter":
      case "datemonth_filter":
      case "dateyear_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.NE:
          case BsyConfig().CONST.FILTER_METHOD.GTE:
          case BsyConfig().CONST.FILTER_METHOD.LTE: {
            return {
              value: filter.value[0]
                ? filter.value[0]
                : null,
            };
            break;
          }
          case BsyConfig().CONST.FILTER_METHOD.RG: {
            return {
              min: filter.value[0] ? filter.value[0] : null,
              max: filter.value[1] ? filter.value[1] : null,
            };
            break;
          }
          case BsyConfig().CONST.FILTER_METHOD.FM: {
            return filter.value;
            break;
          }
          default:
        }
        break;
      }

      case "location_filter":
      case "address_filter":
      case "address_province_filter":
      case "address_city_filter":
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.ALL:
          case BsyConfig().CONST.FILTER_METHOD.NIN: {
            return {
              province: filter.value[0],
              city: filter.value[1],
              district: filter.value[2],
            };
            break;
          }
          default:
        }
        break;

      default:
        if (filter && filter.value) {
          return {
            value: filter.value[0],
          };
        }
        break;
    }
  };

  _dealFilter = (t, n, d) => {
    let e = this;
    if (t && t[0] !== "datatable") {
      BsyUtils.forEach(t, function (t, i) {
        let a = e.context.getOverallSituationValue("widgetsMap")[i];

        if (a) {
          a.setFilter(
            e._getFilter(i),
            e.context.getOverallSituationValue("filter"),
            e.context.getOverallSituationValue("rel")
          );
          a.reload({ skip: 0 });
        }
      });
    } else {
      // 表单查询外链使用
      if (e.props.onCheckAllFilter) {
        let fileEmpty = true;
        //点击筛选按钮重置状态
        BsyUtils.forEach(e.overalDashList, function (a1, b1) {
          // e.widgetsMap[b1].isLoaded = !1;

          let filters = e._getFilter(b1);
          if (
            !BsyUtils.applyFunc(e, e.props.onCheckAllFilter, [b1, filters], !1)
          ) {
            fileEmpty = false;
            return;
          }

          let a = e.context.getOverallSituationValue("widgetsMap")[b1];

          if (a) {
            if (a.doFilterRely) {
              a.doFilterRely(null, e.context.getOverallSituationValue("rel"));
            }
            console.log(3);
            a.setFilter(
              filters,
              e.context.getOverallSituationValue("filter"),
              e.context.getOverallSituationValue("rel")
            );
            a.isload = !1;
          }
        });
        if (fileEmpty) {
          if (e.blocks[0])
            e.context
              .getOverallSituationValue("widgetsMap")
            [e.blockMap[e.blocks[0]].widgetId].loadWidget();
        }
      } else {
        const overalDashList = [...new Set(e.overalDashList)];
        console.log(overalDashList);
        BsyUtils.forEach(overalDashList, function (a1, b1) {
          // e.widgetsMap[b1].isLoaded = !1;

          let filters = e._getFilter(b1);
          let a = e.context.getOverallSituationValue("widgetsMap")[b1];
          if (a) {
            if (a.doFilterRely) {
              a.doFilterRely(null, e.context.getOverallSituationValue("rel"));
            }

            a.setFilter(
              filters,
              e.context.getOverallSituationValue("filter"),
              e.context.getOverallSituationValue("rel")
            );
            a.isload = !1;
          }
        });
        if (n === "isFull") {
          BsyUtils.forEach(overalDashList, function (key, item) {
            if (
              e.context.getOverallSituationValue("widgetsMap")[item].state
                .widget.type !== "base_layout_container"
            ) {
              e.context.getOverallSituationValue("widgetsMap")[item] &&
                e.context
                  .getOverallSituationValue("widgetsMap")
                [item].loadWidget(n, d, 0);
            }
          });
        } else {
          // if (e.blocks[0]) {
          let triggersList = [];
          BsyUtils.forEach(
            this.context.getOverallSituationValue("filter"),
            function (key, item) {
              item.triggers &&
                BsyUtils.forEach(item.triggers, function (key1, item1) {
                  triggersList.push(item1);
                });
            }
          );
          triggersList = [...new Set(triggersList)]; //过滤出数要重置的据表
          console.log(
            "过滤出数要重置的据表",
            triggersList,
            e.context.getOverallSituationValue("widgetsMap")
          );
          if (triggersList.length) {
            BsyUtils.forEach(triggersList, function (key, item) {
              console.log("triggersList", item);
              e.context.getOverallSituationValue("widgetsMap")[item] &&
                e.context
                  .getOverallSituationValue("widgetsMap")
                [item].loadWidget(n, d, 0);
            });
          } else {
            BsyUtils.forEach(overalDashList, function (key, item) {
              if (
                e.context.getOverallSituationValue("widgetsMap")[item].state
                  .widget.type !== "base_layout_container"
              ) {
                e.context.getOverallSituationValue("widgetsMap")[item] &&
                  e.context
                    .getOverallSituationValue("widgetsMap")
                  [item].loadWidget(n, d, 0);
              }
            });
          }

          //     e.widgetsMap[e.blockMap[e.blocks[0]].widgetId].loadWidget(n, d, 0);
          // }
        }
      }
    }
  };

  isElementInViewport = (widget) => {
    // 获取元素是否在可视区域
    if (!this.context.getOverallSituationValue("widgetsMap")[widget.widgetId]) {
      // console.log(widget.title, " 不存在的组件 ")
      return false;
    }
    var widgetRect = this.context
      .getOverallSituationValue("widgetsMap")
    [widget.widgetId].element.current.getBoundingClientRect();
    let elementReact = this.element.current.getBoundingClientRect();

    // console.log('widgetRect',widgetRect,'elementReact',elementReact);
    console.log(widget.title);
    if (
      widgetRect.top >= elementReact.top &&
      widgetRect.top <= elementReact.bottom
    ) {
      // console.log(widget.title, "top 在可见区域")
      return true;
    }

    if (
      widgetRect.bottom <= elementReact.bottom &&
      widgetRect.bottom >= elementReact.top
    ) {
      // console.log(widget.title, "bottom 在可见区域")
      return true;
    }

    if (
      widgetRect.top <= elementReact.top &&
      widgetRect.bottom >= elementReact.bottom
    ) {
      //组件大于当前 可见范围
      // console.log(widget.title, " 组件大于当前 可见范围 ")
      return true;
    }

    // console.log(widget.title, " 不在可见区域 ")
    return false;
  };

  _dealFilterMap = (t) => {
    //当有筛选按钮的时候， _dealFilter不会立即执行
    let e = this;

    if (t) {
      BsyUtils.forEach(t, function (t, i) {
        let a = e.context.getOverallSituationValue("widgetsMap")[i];
        if (a && a.setFilterMap) {
          a.setFilterMap(e.context.getOverallSituationValue("filter"));
        }
      });
    } else {
      BsyUtils.forEach(e.dashList, function (a1, b1) {
        let a = e.context.getOverallSituationValue("widgetsMap")[b1];
        if (a) {
          a.setFilterMap(e.context.getOverallSituationValue("filter"));
        }
      });
    }
  };

  onGetStyles = (id) => {
    if (this.widgetStyleMap && this.widgetStyleMap[id]) {
      return this.widgetStyleMap[id];
    }
    // 处理容器内的自定义样式属性
    if (this.state.containiershowStyle === "base_layout_container") {
      const widget = this.state.components[id];
      this._getWidgetStyle(this.styles, widget);
      return this.widgetStyleMap[id];
    }

    return null;
  };

  onClick = () => {
    let that = this;
    this.autoLoad = !0;
    this.setContainiersAutoLoad(this.autoLoad);
    let triggers = [];
    this.quikerFilter(11);
    BsyUtils.forEach(that.Acomponents.entry.components, function (key, item) {
      if (item.type === "filte_quick") {
        BsyUtils.forEach(
          item.combineFilterModel.combineFilter,
          function (key1, item1) {
            BsyUtils.forEach(item1.filters, function (key2, item2) {
              triggers = triggers.concat(item2.triggers);
            });
          }
        );
      }
      if (item.type.indexOf("_filter") >= 0) {
        triggers = triggers.concat(item.triggers);
      }
    });

    triggers = [...new Set(triggers)];
    console.log();
    this._dealFilter(triggers);

    // this._dealFilter()
  };
  onClear = () => {
    let that = this;
    let t = this.state;

    BsyUtils.forEach(t.allComponentDash.entry.components, function (t, i) {
      if (i.type.indexOf("filte") > -1) {
        // //清空filter组件
        let context =
          that.context.getOverallSituationValue("widgetsMap")[i.widgetId];
        if (context) {
          context.clearConfig();
          context.setDefaultConfig();
        }
      }
      if (i.type.indexOf("_filter") > -1) {
        //清空快捷筛选组件
        let context =
          that.context.getOverallSituationValue("widgetsMap")[i.widgetId];
        if (context) {
          context.componentContext.clearValue();
        }
      }
    });
    // 清空组件回调结束

    let filterClear = that.context.getOverallSituationValue("filter");
    BsyUtils.forEach(filterClear, function (index, item) {
      if (item.value) {
        switch (typeof item.value) {
          case "object":
            item.value = [];
            break;
          case "string":
            item.value = "";
            break;
          default:
        }
      }
    });

    if(that.state.mode === "dataload") {
      // 表单查询外链，重置条件就可以了，不需要请求数据表
      that.context.upOverallSituationValue("filter", filterClear)
      return;
    }

    const overalDashList = [...new Set(that.overalDashList)];
    BsyUtils.forEach(overalDashList, function (a1, b1) {
      // e.widgetsMap[b1].isLoaded = !1;

      let a = that.context.getOverallSituationValue("widgetsMap")[b1];
      if (a) {
        if (a.doFilterRely) {
          a.doFilterRely(null, that.context.getOverallSituationValue("rel"));
        }
        a.setFilter({}, {}, that.context.getOverallSituationValue("rel"));
        a.isload = !1;
      }
    });

    let triggersList = [];
    BsyUtils.forEach(
      this.context.getOverallSituationValue("filter"),
      function (key, item) {
        item.triggers &&
          BsyUtils.forEach(item.triggers, function (key1, item1) {
            triggersList.push(item1);
          });
      }
    );
    triggersList = [...new Set(triggersList)]; //过滤出数要重置的据表
    if (triggersList.length) {
      BsyUtils.forEach(triggersList, function (key, item) {
        that.context.getOverallSituationValue("widgetsMap")[item] &&
          that.context
            .getOverallSituationValue("widgetsMap")
          [item].loadWidget(null, null, 0);
      });
    } else {
      BsyUtils.forEach(overalDashList, function (key, item) {
        if (
          that.context.getOverallSituationValue("widgetsMap")[item].state.widget
            .type !== "base_layout_container"
        ) {
          that.context.getOverallSituationValue("widgetsMap")[item] &&
            that.context
              .getOverallSituationValue("widgetsMap")
            [item].loadWidget(null, null, 0);
        }
      });
    }
    //上面一截不清楚啥逻辑，复制的代码，也没个备注
  };
  updateTime = [];

  onComponentReSize = (isComponentFull) => {
    this.setState({
      isComponentFull: isComponentFull,
    });
  };

  autoRefresh = () => {
    const { autoRefresh, appId, components, isDashFull } = this.state;
    let that = this;

    if (!isDashFull) {
      //非大屏的情况下，禁止自动刷新
      if (window.dashSetInterval && window.dashSetInterval) {
        clearInterval(window.dashSetInterval);
        window.dashSetInterval = null;
      }
      return;
    }

    if (autoRefresh && autoRefresh.enabled) {
      // const appId = dashConfig.appId;
      let data = [];
      let formIdList = [];
      //记录每个 components 的刷新时间
      // this.refreshMap = this.refreshMap || {}; // widgetId || appId.formId 对应关系
      var refreshMap = that.context.getOverallSituationValue("refreshMap");

      // this.refresWidgetMapTime = this.refresWidgetMapTime || {};  //widget : updataTime  每个组件最后更新时间

      // this.refreshNewUpdataTime = this.refreshNewUpdataTime || {}; // appId.formId : updataTime 根据appid formid 建议最新的对应关系

      //缓存所有表单ID 用于后续判断 刷新的逻辑
      BsyUtils.forEach(components, (key, val) => {
        if (!val) {
          return;
        }
        if (!val.forms) {
          return;
        }
        if (!val.forms[0]) {
          return;
        }

        if (val.forms[0].indexOf("@") > -1) {
          refreshMap[val.widgetId] = [
            val.forms[0].split("@")[1],
            val.forms[0].split("@")[0],
          ].join(".");

          // that.refreshMap[val.widgetId] = [val.forms[0].split("@")[1], val.forms[0].split("@")[0]].join('.')
        } else {
          refreshMap[val.widgetId] = [appId, val.forms[0]].join(".");

          // that.refreshMap[val.widgetId] = [appId, val.forms[0]].join('.')
        }

        that.context.upOverallSituationValue("refreshMap", refreshMap);

        if (formIdList.indexOf(val.forms[0]) === -1) {
          if (val.forms[0].indexOf("@") > -1) {
            data.push({
              appId: val.forms[0].split("@")[1],
              formId: val.forms[0].split("@")[0],
            });
          } else {
            data.push({
              appId,
              formId: val.forms[0],
            });
          }
          formIdList.push(val.forms[0]);
        }
      });
      let timeNum = this.state.autoRefresh.autoRefreshTime;
      if (this.state.autoRefresh.autoRefreshTime === "custom") {
        timeNum = this.state.autoRefresh.autoRefreshTimeNum;
      }
      // React.axios("/data/get_update_time", data).then((res) => {
      // this.updateTime = res.data;
      // this.bsyDashContext && this._dealFilter && this._dealFilter();

      window.dashSetInterval = window.dashSetInterval || null;

      if (window.dashSetInterval) {
        clearInterval(window.dashSetInterval);
        window.dashSetInterval = null;
      }
      var refreshNewUpdataTime = that.context.getOverallSituationValue(
        "refreshNewUpdataTime"
      );
      window.dashSetInterval = setInterval(() => {
        React.axios("/data/get_update_time", data)
          .then((res) => {
            // let flg = false;

            for (let i = 0; i < res.data.length; i++) {
              // that.refreshNewUpdataTime[[res.data[i].appId, res.data[i].formId].join('.')] = res.data[i].updateTime
              refreshNewUpdataTime[
                [res.data[i].appId, res.data[i].formId].join(".")
              ] = res.data[i].updateTime;
            }
            that.context.upOverallSituationValue(
              "refreshNewUpdataTime",
              refreshNewUpdataTime
            );
            if (window.dashSetInterval) {
              clearInterval(window.dashSetInterval);
              window.dashSetInterval = null;
            }
            this._dealFilter && this._dealFilter(false, "isFull");
          })
          .catch((res) => {
            console.log(res);
          });
      }, timeNum * 1000);
      // }).catch(res => {
      //     console.log(res)
      // })
    }
  };

  checkTime = (widget) => {
    let key =
      this.context.getOverallSituationValue("refreshMap")[widget.widgetId];

    // if (this.refresWidgetMapTime[widget.widgetId] !== this.refreshNewUpdataTime[key]) {
    //     this.refresWidgetMapTime[widget.widgetId] = this.refreshNewUpdataTime[key]
    //     return true;
    // }
    var refresWidgetMapTime = this.context.getOverallSituationValue(
      "refresWidgetMapTime"
    );

    if (
      refresWidgetMapTime[widget.widgetId] !==
      this.context.getOverallSituationValue("refreshNewUpdataTime")[key]
    ) {
      refresWidgetMapTime[widget.widgetId] =
        this.context.getOverallSituationValue("refreshNewUpdataTime")[key];
      this.context.upOverallSituationValue(
        "refresWidgetMapTime",
        refresWidgetMapTime
      );
      return true;
    }

    return false;
  };

  getRawDataForm = (widget, filter) => {
    const { appId, entryId, mode } = this.state;
    if (mode === "preview") {
      return;
    }
    let orgAppid = appId;
    let orgEntryId = widget.forms[0];
    if (orgEntryId.indexOf("@") > -1) {
      let ss = orgEntryId.split("@");
      orgAppid = ss[1];
      orgEntryId = ss[0];
    }
    let globalFilter = [];
    console.log(this.context.getOverallSituationValue("filter"));
    BsyUtils.forEach(
      this.context.getOverallSituationValue("filter"),
      (a1, item) => {
        if (a1 == "rel") return;
        if (item.triggers.indexOf(widget.widgetId) > -1) {
          globalFilter.push(item);
        }
      }
    );
    console.log(filter, globalFilter);
    if (filter) {
      if (globalFilter && globalFilter.length) {
        filter = filter.concat(globalFilter);
      }
    } else {
      filter = globalFilter;
    }

    const config = {
      appId: orgAppid,
      entryId: orgEntryId,
      extDashData: {
        appId: appId,
        formId: widget.forms[0],
        entryId: entryId,
        widgetId: widget.widgetId,
      },
    };
    ///dashboard/app/5839bdd7d7e9cc44b6ffbaa8/entry/571b9e2b9ce48ce22913d878
    React.axios("/dashboard/app/" + orgAppid + "/entry/" + orgEntryId, config)
      .then((res) => {
        console.log(res.data);
        this.popupRawData(res.data, filter, widget);
      })
      .catch((err) => { });
  };

  popupRawData = (entryConfig, filter, widget) => {
    const { appId, entryId } = this.state;
    const { entry, authGroups, is_dock_form } = entryConfig;
    // let f = {};
    let ptlist = [];
    let f = authGroups[0];

    if (f.printId) {
      BsyUtils.forEach(f.printId, function (k, v) {
        ptlist.push({
          printId: k,
          name: v.name,
        });
      });
    }

    let showFields = [];
    window.$.map(f.optAuth, function (v, k) {
      if (v.visible) showFields.push(k);
    });
    let g = window.FX.Store.getKey("paramFields", {
      appId: entry.appId,
      entryId: entry.entryId,
      groupId: 0,
    });
    var h = window.FX.Store.getKey("showFields", {
      appId: entry.appId,
      entryId: entry.entryId,
      groupId: 0,
    });
    var i = window.FX.Store.getKey("metaFields", {
      appId: entry.appId,
      entryId: entry.entryId,
      groupId: 0,
    });
    // window.FX.STATIC.DECISION_SWITCH = (formConfig.attr.flow && formConfig.attr.flow.decision && formConfig.attr.flow.decision.switch) ? formConfig.attr.flow.decision.switch : false;
    // window.FX.STATIC.PublicData = formConfig.attr.PublicData
    let config = {
      appId: entry.appId,
      entryId: entry.entryId,
      formId: entry.entryId,
      formName: entry.name,
      formTabs: entry.formTabs,
      formTabsStyle: entry.formTabsStyle || {},
      formItems: entry.content.items,
      submitAttr: entry.content.submitAttr,
      data_cache: entry.content.data_cache,
      enableRowEdit: entry.enableRowEdit,
      quickEdit: entry.quickEdit,
      initializeModuleEvent: entry.content.initializeModuleEvent,
      initializeDataExtendSet: entry.content.initializeDataExtendSet,
      widgetId: widget.widgetId,
      is_dock_form: is_dock_form,
      formAttr: {
        submitRule: entry.content.submitRule,
        layout: entry.content.layout,
        validators: entry.content.validators,
        confirmSettings: entry.content.confirmSettings,
        fieldShowRules: entry.content.fieldShowRules,
        subformFieldShowRules: entry.content.subformFieldShowRules,
      },
      originPrint: "group",
      hasExtParams: entry.hasExtParams,
      hasUserSource: entry.hasUserSource === true,
      hasFlow: entry.hasFlow,
      hasCoop: entry.hasCoop,
      flow: entry.flow,
      dataPerms: f.dataPerms,
      optAuth: f.optAuth,
      ptlist: ptlist,
      hasFilter: false,
      filter: filter,
      rel: this.context.getOverallSituationValue("rel"),
      authGroupId: 0,
      showFieldsFilter: window.FX.Store.get(g),
      showFields: window.FX.Store.get(h),
      showFieldsMeta: window.FX.Store.get(i),
      printId: f.printId,
      // url: '/data/dash_process_list',
      url: "/data/_list",
      onParamFieldSelect: function (a) {
        window.FX.Store.set(g, a);
      },
      onDataFieldSelect: function (a) {
        window.FX.Store.set(h, a);
      },
      onDataFieldMetaChange: function (a) {
        window.FX.Store.set(i, a);
      },
      extDashData: {
        appId: appId,
        entryId: entryId,
        formId: widget.forms[0],
        widgetId: widget.widgetId,
      },
    };
    BsySlidePane({
      title: React.language("view.raw.data"),
      hasHeader: true,
      onContentCreate: (ref) => {
        return <BsyDataManage {...config} />;
      },
      onClose: () => {
        let componentContext =
          this.context.getOverallSituationValue("widgetsMap")[widget.widgetId];

        componentContext.reload({
          skip: 0,
          sort: widget.defaultSort,
          filter: null,
        });

        return true;
      },
    });
  };

  render() {
    const {
      componentsArray,
      mode,
      allComponentDash,
      appId,
      entryId,
      autoRefresh,
      dashTitle,
    } = this.state;

    let that = this;
    return (
      <div
        className={
          "bsy-dash " + this.theme + ` ${mode} ` + that.props.rootTokenDashClass
        }
        ref={this.element}
      >
        {componentsArray.map((block) => {
          let s = this._getSize(block);
          //非法的数据格式
          if (!block || !block.widgetId) {
            return "";
          }

          //判断是否要监听鼠标位置
          // if (!BsyUtils.isObjectEmpty(block.triggers) && block.rawdata) {
          if (!window.GlobalMouse) {
            window.GlobalMouse = {};
            document.addEventListener("mousedown", (event) => {
              window.GlobalMouse = event;
            });
          }
          // }

          return (
            <div
              key={"dash-" + block.widgetId}
              className={
                "dash-react-block " + block.type + " " + block.widgetId
              }
              style={{
                top: s.y,
                left: s.x,
                width: block.type === "webPage" ? "100%" : s.width,
                height:
                  block.type === "webPage" ? "calc(100% - 10px)" : s.height,
                display: isNaN(s.y) ? "none" : "block",
              }}
            >
              <BsyDashComponent
                widget={{
                  ...block,
                  appId: appId,
                  entryId: entryId,
                  mode: block.mode ? block.mode : mode,
                  theme: this.theme,
                  dashTitle: dashTitle,
                }}
                // rel={this.rel}
                isDashFull={this.state.isDashFull}
                is_dock_form={this.props.is_dock_form}
                autoRefresh={autoRefresh}
                key={"BsyDashComponent-" + block.widgetId}
                popupFormPath={[...this.popupFormPath]}
                allComponentDash={allComponentDash}
                // widgetsMap={this.widgetsMap}
                widgetsObject={this.widgetsObject}
                widgetsValue={this.widgetsValue}
                // globFilter={this.filter}
                overallBlocks={this.overallBlocks}
                overalDashList={this.overalDashList}
                overallBlockMap={this.overallBlockMap}
                // refreshMap={this.refreshMap}
                // refresWidgetMapTime={this.refresWidgetMapTime}
                // refreshNewUpdataTime={this.refreshNewUpdataTime}
                mode={mode}
                autoLoad={false}
                mountAutoLoad={false}
                lazyLoading={this.state.hasLazyLoad}
                operates={[]}
                getContext={this.getContext}
                onGetStyles={this.onGetStyles}
                // onComponentReSize={this.onComponentReSize}
                onIsElementInViewport={() => {
                  let viewport = that.isElementInViewport(block);
                  if (viewport) {
                    viewport = that.checkTime(block);
                    // that.refreshMapUpdataTime[block.widgetId] =
                  }
                  return viewport;
                }}
                onItemClick={(filter, cb) => {
                  var drilling =
                    block.type === "map_chart" &&
                    (block.hasOwnProperty("drilling")
                      ? block.drilling !== "none"
                      : true);
                  if (
                    (!BsyUtils.isObjectEmpty(block.triggers) ||
                      !BsyUtils.isObjectEmpty(block.customizeTriggers)) &&
                    block.rawdata &&
                    drilling
                  ) {
                    console.log(window.GlobalMouse);
                    let menu = [];
                    menu.push({
                      text: React.language("report.link"),
                      click: () => {
                        that._triggerLink(
                          { ...block, appId: appId, entryId: entryId },
                          filter
                        );
                      },
                    });
                    menu.push({
                      text: React.language("dash.drilling"),
                      click: () => {
                        cb && cb();
                      },
                    });
                    menu.push({
                      text: React.language("view.raw.data"),
                      click: () => {
                        var d =
                          that.context.getOverallSituationValue("widgetsMap")[
                          block.widgetId
                          ];
                        let deFilter = filter || [];

                        if (d.filter && deFilter) {
                          deFilter = deFilter.concat(d.filter);
                        }
                        if (d.linkFilter && deFilter) {
                          deFilter = deFilter.concat(d.linkFilter);
                        }
                        that.getRawDataForm({ ...block }, deFilter);
                      },
                    });

                    BsyAlertMenu({
                      item: menu,
                      width: 220,
                      target: null,
                      position: {
                        left: window.GlobalMouse.pageX,
                        top: window.GlobalMouse.pageY,
                      },

                      theme: that.theme,
                      onClose: () => { },
                    });
                  } else if (block.rawdata && drilling) {
                    let menu = [];

                    menu.push({
                      text: React.language("dash.drilling"),
                      click: () => {
                        cb && cb();
                      },
                    });
                    menu.push({
                      text: React.language("view.raw.data"),
                      click: () => {
                        var d =
                          that.context.getOverallSituationValue("widgetsMap")[
                          block.widgetId
                          ];
                        let deFilter = filter || [];

                        if (d.filter && deFilter) {
                          deFilter = deFilter.concat(d.filter);
                        }
                        if (d.linkFilter && deFilter) {
                          deFilter = deFilter.concat(d.linkFilter);
                        }
                        that.getRawDataForm({ ...block }, deFilter);
                      },
                    });

                    BsyAlertMenu({
                      item: menu,
                      width: 220,
                      target: null,
                      position: {
                        left: window.GlobalMouse.pageX,
                        top: window.GlobalMouse.pageY,
                      },
                      theme: that.theme,
                      onClose: () => { },
                    });
                  } else if (
                    (!BsyUtils.isObjectEmpty(block.triggers) ||
                      !BsyUtils.isObjectEmpty(block.customizeTriggers)) &&
                    drilling
                  ) {
                    let menu = [];
                    menu.push({
                      text: React.language("report.link"),
                      click: () => {
                        that._triggerLink(
                          { ...block, appId: appId, entryId: entryId },
                          filter
                        );
                      },
                    });

                    menu.push({
                      text: React.language("dash.drilling"),
                      click: () => {
                        cb && cb();
                      },
                    });

                    BsyAlertMenu({
                      item: menu,
                      width: 220,
                      target: null,
                      position: {
                        left: window.GlobalMouse.pageX,
                        top: window.GlobalMouse.pageY,
                      },
                      theme: that.theme,
                      onClose: () => { },
                    });
                  } else if (
                    (!BsyUtils.isObjectEmpty(block.triggers) ||
                      !BsyUtils.isObjectEmpty(block.customizeTriggers)) &&
                    block.rawdata
                  ) {
                    let menu = [];
                    menu.push({
                      text: React.language("report.link"),
                      click: () => {
                        that._triggerLink(
                          { ...block, appId: appId, entryId: entryId },
                          filter
                        );
                      },
                    });
                    menu.push({
                      text: React.language("view.raw.data"),
                      click: () => {
                        var d =
                          that.context.getOverallSituationValue("widgetsMap")[
                          block.widgetId
                          ];
                        let deFilter = filter || [];

                        if (d.filter && deFilter) {
                          deFilter = deFilter.concat(d.filter);
                        }
                        if (d.linkFilter && deFilter) {
                          deFilter = deFilter.concat(d.linkFilter);
                        }
                        that.getRawDataForm({ ...block }, deFilter);
                      },
                    });
                    BsyAlertMenu({
                      item: menu,
                      width: 220,
                      target: null,
                      position: {
                        left: window.GlobalMouse.pageX,
                        top: window.GlobalMouse.pageY,
                      },
                      theme: that.theme,
                      onClose: () => { },
                    });
                  } else if (
                    !BsyUtils.isObjectEmpty(block.triggers) ||
                    !BsyUtils.isObjectEmpty(block.customizeTriggers)
                  ) {
                    that._triggerLink(
                      { ...block, appId: appId, entryId: entryId },
                      filter
                    );
                    if (block.drilling !== "none") {
                      cb && cb();
                    }
                  } else if (block.rawdata) {
                    var d =
                      that.context.getOverallSituationValue("widgetsMap")[
                      block.widgetId
                      ];
                    let deFilter = filter || [];

                    if (d.filter && deFilter) {
                      deFilter = deFilter.concat(d.filter);
                    }
                    if (d.linkFilter && deFilter) {
                      deFilter = deFilter.concat(d.linkFilter);
                    }
                    that.getRawDataForm({ ...block }, deFilter);
                  } else if (block.drilling !== "none") {
                    cb && cb();
                  }
                }}
                onClearLink={(filter) => {
                  if (BsyUtils.isObjectEmpty(filter)) {
                    tipAlert({
                      type: "warning",
                      msg: React.language("dash.link.empty"),
                    });
                  } else {
                    that._triggerLink(
                      { ...block, appId: appId, entryId: entryId },
                      {}
                    );
                    tipAlert({
                      type: "success",
                      msg: React.language("dash.link.canceled"),
                    });
                  }
                }}
                onLoadSuccess={(id, n, d) => {
                  if (!this.state.hasLazyLoad) {
                    let t = block.widgetId;
                    let index = that.dashList.indexOf(t);
                    // console.log('onLoadSuccess       ---' + that.widgetsMapName[t] + '---')
                    // let nextName = that.widgetsMapName[that.dashList[index + 1]];
                    // console.log('onLoadSuccess next  ---' + nextName + '---')
                    if (index + 1 < that.dashList.length) {
                      let e =
                        that.context.getOverallSituationValue("widgetsMap")[
                        that.dashList[index + 1]
                        ];
                      // console.log('onLoadSuccess next1 ---' + nextName + '---')
                      if (e && !e.isWidgetLoaded()) {
                        // ???? 2022 01 12 id的判断 不记得逻辑的，观察 //&& this.entryId == FX.STATIC.ENTRYID)
                        // console.log('onLoadSuccess next2 ---' + nextName + '---')
                        e.loadWidget(n, d);
                        // console.log('onLoadSuccess next3 ---' + nextName + '---')
                      }
                      // console.log('onLoadSuccess next4 ---' + nextName + '---')
                    } else {
                      that.autoRefresh(n, d);
                    }
                  }

                }}
                onLoadFail={(id, n, d) => {
                  if (!this.state.hasLazyLoad) {
                    let t = block.widgetId;
                    // console.log('onLoadFail ---' + that.widgetsMapName[t] + '---')
                    let index = that.dashList.indexOf(t);
                    if (index + 1 < that.dashList.length) {
                      let e =
                        that.context.getOverallSituationValue("widgetsMap")[
                        that.dashList[index + 1]
                        ];
                      if (e && !e.isWidgetLoaded()) {
                        // ???? 2022 01 12 id的判断 不记得逻辑的，观察 //&& this.entryId == FX.STATIC.ENTRYID)
                        e.loadWidget(n, d);
                      }
                    } else {
                      that.autoRefresh(n, d);
                    }
                  }

                }}
                onRefreshChars={(chars) => {
                  if (!BsyUtils.isObjectEmpty(chars)) {
                    BsyUtils.forEach(chars, function (charsIndex, charsData) {
                      if (
                        that.context.getOverallSituationValue("widgetsMap")[
                        charsData
                        ]
                      ) {
                        that.context
                          .getOverallSituationValue("widgetsMap")
                        [charsData].loadWidget();
                      }
                    });
                  }
                }}
                onIsAutoLoad={() => {
                  let r = that.autoLoad === false ? false : true;
                  let t = block.widgetId;
                  if (r === false) {
                    if (that.dashMap.hasOwnProperty(block.widgetId)) {
                      let e =
                        that.context.getOverallSituationValue("widgetsMap")[
                        that.dashMap[t]
                        ];
                      if (e && !e.isWidgetLoaded()) {
                        // ???? 2022 01 12  id的判断 不记得逻辑的，观察 //&& this.entryId == FX.STATIC.ENTRYID)
                        e.loadWidget();
                      }
                    }
                  }
                  return r;
                }}
                onStopEdit={(t) => {
                  that.onFilterStopEdit(t, block);
                }}
                onChooseUpItem={(t, widgetId, type) => {
                  this.onQuikerFilterItem(t, widgetId, type);
                }}
                // onDataFilter
                onClick={that.onClick}
                onClear={that.onClear}
              />
              <div className="angle-cursor nw-cursor"></div>
              <div className="angle-cursor ne-cursor"></div>
              <div className="angle-cursor se-cursor"></div>
              <div className="angle-cursor sw-cursor"></div>
            </div>
          );
        })}
        <div className="bsy-block-full-screen-mask dash-theme-dark"></div>
      </div>
    );
  }
}
BsyDash.contextType = WindowPropsContext;
export default BsyDash;
